import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-templates/new/loading';

export const Route = createFileRoute('/_private/settings/terms-templates/new')({
  component: Loading,
});
